import { Link } from "react-router-dom";

export function Logo({ light = false, className = "" }) {
  return (
    <Link to="/" className={`inline-flex items-baseline font-display font-bold tracking-tight ${className}`} data-testid="logo-link">
      <span className={light ? "text-white" : "text-[#111827]"}>Homio</span>
      <span className="text-[#C81D35]">.</span>
    </Link>
  );
}
